import { get } from 'api/request';
import urls from 'configs/urls';

export const getCountries = () => get(null, false, urls.common.getCountries, null);
